import React from 'react'
import { Avatar, Image, Input, Button, Upload, message, Modal } from 'antd'
import Icon, {
  WechatOutlined,
  AntDesignOutlined,
  SettingOutlined,
  EyeOutlined,
  MessageOutlined,
  UserOutlined,
  NotificationFilled,
  PhoneOutlined,
  EnvironmentOutlined,
  MailOutlined,
  NodeIndexOutlined,
  LeftOutlined,
  EditOutlined,
  TagOutlined,
  GlobalOutlined,
  RestOutlined,
} from '@ant-design/icons'
import { ReactComponent as img } from '../../icons/bbs/img.svg'
import Nav from '../../component/nav/nav'
import Foot from '../../component/Foot/Foot'
import APagination from '../../component/Pagination/Pagination'
import ImgCrop from 'antd-img-crop'

import intl from 'react-intl-universal'

import person from '../../api/user'
import column from '../../api/column'
import forum from '../../api/bbs'
import CHAT from '../../api/chat'
import merchantsInfo from '../../api/yellow'
import ReactWebsocket from './components/ReactWebsocket'
import './components/myplace.css'
import { InfiniteScroll, Loading, Popup } from 'antd-mobile'

import BraftEditor from 'braft-editor'
import 'braft-editor/dist/index.css'
// const { TextArea } = Input;
const controls = ['emoji', 'media']

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default class Myplace extends React.Component {
  constructor() {
    super()
    this.state = {
      checkedtap: 1,
      userData: {},
      shopData: [],
      shopPageSize: 10,
      shopPageNum: 1,
      shopTotal: 0,
      shopCategorys: [],
      selectCategory: '',
      bbsData: [],
      bbsTotal: 0,
      bbsPageSize: 10,
      bbsPageNum: 1,
      postBbsData: [],
      postBbsTotal: 0,
      postBbsPageSize: 10,
      postBbsPageNum: 1,
      fileList: [],
      mainpathparms: {
        type: 5,
      },
      headers: {
        'X-Requested-With': null,
        // authorization: 'authorization-text',
        token: '',
      },

      editData: '',
      editVisible: false,
      editTitle: '',
      editTab: '',
      nowpassword: '',
      userpassword: '',
      myShopData: [],
      clickKey: 1,
      hasMore: true,
      hasMore2: true,
      hasMore3: true,
      visible: false,
      liveMessage: BraftEditor.createEditorState(),

      chatData: [],
      chooseKey: '',
      chatItem: {},
      deleteVisible: false,
    }
  }

  componentDidMount() {
    this.getUser()
    this.getCollectShop({})
    this.getShopListByApi({})
    this.getBbsCollect({})
    this.getPostBbs({})
    this.getHistory()
  }

  componentWillUnmount() {
    this.onClose()
  }

  reflash = () => {
    person
      .customerDetail(
        {
          customerId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
            .id,
        },
        JSON.parse(sessionStorage.getItem('USERDATA'))?.token
      )
      .then(res => res.json())
      .then(result => {
        console.log('result', result)
        let userData = {
          customer: result.data,
          token: JSON.parse(sessionStorage.getItem('USERDATA'))?.token,
        }
        const userdata = JSON.stringify(userData)
        sessionStorage.setItem('USERDATA', userdata)
        this.setState(
          {
            userData: result.data,
            checkedtap: 5,
          },
          () => {
            window.location.reload()
          }
        )
      })
  }

  // 用户信息
  getUser = () => {
    person
      .customerDetail(
        {
          customerId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
            .id,
        },
        JSON.parse(sessionStorage.getItem('USERDATA'))?.token
      )
      .then(res => res.json())
      .then(result => {
        console.log('result', result)

        this.setState(
          {
            userData: result.data,
            checkedtap: result.data?.isMerchants === 2 ? 6 : 1,
          },
          () => {
            this.getShopData({})
          }
        )
      })
  }

  // 店铺收藏
  getCollectShop = ({
    pageSize = this.state.shopPageSize,
    pageNum = this.state.shopPageNum,
  }) => {
    person
      .myCollectList(
        {
          customerId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
            .id,
          language: sessionStorage['language'],
          categoryId: this.state.selectCategory,
          pageSize,
          pageNum,
        },
        JSON.parse(sessionStorage.getItem('USERDATA'))?.token
      )
      .then(res => res.json())
      .then(result => {
        console.log('result2', result)
        if (result.ret === 200) {
          this.setState({
            shopData: result.data.list,
            shopTotal: result.data.totalCount,
          })
        }
      })
  }

  // 店铺分类
  getShopListByApi = ({
    parentId = 2,
    language = sessionStorage['language'],
    stat = 1,
  }) => {
    column
      .columnInfoWeb({ parentId, language, stat })
      .then(res => res.json())
      .then(result => {
        if (result.ret === 200) {
          this.setState({
            shopCategorys: result.data,
          })
        }
      })
  }

  // 店铺收藏分页
  handleChangeShopPage = (page, pageSize) => {
    this.setState(
      {
        shopPageNum: page,
        shopPageSize: pageSize,
      },
      () => {
        this.getCollectShop({})
      }
    )
  }

  // 店铺收藏分类
  handleSelect = e => {
    this.setState(
      {
        selectCategory: e,
        shopPageNum: 1,
      },
      () => {
        this.getCollectShop({})
      }
    )
  }

  // 帖子收藏
  getBbsCollect = ({
    pageSize = this.state.bbsPageSize,
    pageNum = this.state.bbsPageNum,
  }) => {
    person
      .myForumwebCollectList(
        {
          customerId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
            .id,
          pageSize,
          pageNum,
        },
        JSON.parse(sessionStorage.getItem('USERDATA'))?.token
      )
      .then(res => res.json())
      .then(result => {
        if (result.ret === 200) {
          this.setState({
            bbsData: result.data.list,
            bbsTotal: result.data.totalCount,
          })
        }
      })
  }

  // 帖子收藏分页
  handleChangeBbsPage = (page, pageSize) => {
    this.setState(
      {
        bbsPageNum: page,
        bbsPageSize: pageSize,
      },
      () => {
        this.getBbsCollect({})
      }
    )
  }

  // 已发帖子
  getPostBbs = () => {
    forum
      .forumListWeb({
        customerId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        pageSize: this.state.postBbsPageSize,
        pageNum: this.state.postBbsPageNum,
      })
      .then(res => res.json())
      .then(result => {
        if (result.ret === 200) {
          this.setState({
            postBbsData: result.data.list,
            postBbsTotal: result.data.totalCount,
          })
        }
      })
  }

  // 已发帖子分页

  handleChangePostBbsPage = (page, pageSize) => {
    this.setState(
      {
        postBbsPageNum: page,
        postBbsPageSize: pageSize,
      },
      () => {
        this.getPostBbs({})
      }
    )
  }

  weatherPath = item => {
    if (!item.path) {
      return
    } else {
      return (
        <Icon
          component={img}
          style={{
            fontSize: '.16rem',
            paddingLeft: '.12rem',
            color: '#ffffff',
          }}
          className="init-icons"
        />
      )
    }
  }

  handleChangeTab = val => {
    console.log('val', val)
    this.setState(
      {
        checkedtap: val,
      },
      () => {
        if (this.state.checkedtap === 4) {
          var div = document.getElementById('contentmessage')
          div.scrollTop = div.scrollHeight
        }
      }
    )
  }

  handleCancel = () => this.setState({ previewVisible: false })

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
    })
  }

  handleChange = ({ fileList }) => {
    console.log('fileList', fileList)
    if (fileList[0].status === 'done') {
      const parms = {
        path: fileList[0].response.data.content.picPath[0],
        id: this.state.userData.id,
      }
      person
        .updaeCus(parms, JSON.parse(sessionStorage.getItem('USERDATA')).token)
        .then(res => res.json())
        .then(result => {
          console.log('result233', result)
          if (result.ret === 200) {
            message.success(intl.get('XIUGAICHNGGONG'))
            this.reflash()
          }
        })
    }

    this.setState({ fileList })
  }

  handleEdit = e => {
    switch (e) {
      case 1:
        this.setState({
          editTab: 1,
          editData: this.state.userData.account,
          editVisible: true,
          editTitle: intl.get('XIUGAINICHENG'),
        })
        break
      case 2:
        this.setState({
          editTab: 2,
          editData: this.state.userData.personName,
          editVisible: true,
          editTitle: intl.get('XIUGAIXINGMING'),
        })
        break
      case 3:
        this.setState({
          editTab: 3,
          editData: this.state.userData.email,
          editVisible: true,
          editTitle: intl.get('YOUXIANG'),
        })
        break
      case 4:
        this.setState({
          editTab: 4,
          editData: this.state.userData.phone,
          editVisible: true,
          editTitle: intl.get('SHOUJIHAOMA'),
        })
        break
      case 5:
        this.setState({
          editTab: 5,
          editData: this.state.userData.phone,
          editVisible: true,
          editTitle: intl.get('SHOUJIHAOMA'),
        })
        break
      case 6:
        this.setState({
          editTab: 6,
          editData: this.state.userData.wechat,
          editVisible: true,
          editTitle: intl.get('WEIXINHAO'),
        })
        break
      default:
        break
    }
  }

  handleChangeEdit = e => {
    this.setState({
      editData: e.target.value,
    })
  }

  handleChangenowpassword = e => {
    this.setState({
      nowpassword: e.target.value,
    })
  }

  handleChangepass = e => {
    this.setState({
      userpassword: e.target.value,
    })
  }

  goToDetail = e => {
    sessionStorage['SHOPID'] = e
    let urlParms = JSON.stringify(e)
    this.props.history.push(`/yellowPagesDetail/${urlParms}`)
  }

  handleToDetail = e => {
    sessionStorage['BBSTOPICID'] = e
    let urlParms = JSON.stringify(e)
    this.props.history.push(`/bbspagedetail/${urlParms}`)
  }

  handleToEditDetail = val => {
    console.log(val, 'val')
    let xxx = val
    xxx.regionId = xxx.regionId.split(',').map(item => {
      return Number(item)
    })
    console.log(xxx, 'xxx')
    sessionStorage['BBSEDITDATA'] = JSON.stringify(xxx)
    this.props.history.push('/bbspagenew')
  }

  handleToDelete = val => {
    console.log('va', val)
    this.setState({
      deleteVisible: true,
      deleteId: val.id,
    })
  }

  handleToConfirmDelete = () => {
    person
      .deleteForumTopic(
        {
          topicId: this.state.deleteId,
        },
        JSON.parse(sessionStorage.getItem('USERDATA')).token
      )
      .then(res => res.json())
      .then(result => {
        if (result.ret === 200) {
          this.setState(
            {
              deleteVisible: false,
            },
            () => {
              this.getPostBbs({})
            }
          )
        }
      })
  }

  diffComponent = () => {
    if (this.state.editTab === 5) {
      return (
        <>
          <Input.Password
            placeholder={intl.get('MIMA')}
            value={this.state.nowpassword}
            onChange={this.handleChangenowpassword}
          />
          <div style={{ padding: '10px' }}></div>
          <Input.Password
            placeholder={intl.get('QUERENXINMIM')}
            value={this.state.userpassword}
            onChange={this.handleChangepass}
          />
        </>
      )
    } else {
      return (
        <>
          <Input
            placeholder={this.state.editTitle}
            value={this.state.editData}
            onChange={this.handleChangeEdit}
          />
        </>
      )
    }
  }

  handleOk = () => {
    switch (this.state.editTab) {
      case 1:
        person
          .updaeCus(
            {
              account: this.state.editData,
              id: this.state.userData.id,
            },
            JSON.parse(sessionStorage.getItem('USERDATA')).token
          )
          .then(res => res.json())
          .then(result => {
            console.log('result233', result)
            if (result.ret === 200) {
              message.success(intl.get('XIUGAICHNGGONG'))
              this.setState(
                {
                  editVisible: false,
                },
                () => {
                  this.reflash()
                }
              )
            }
          })
        break
      case 2:
        person
          .updaeCus(
            {
              personName: this.state.editData,
              id: this.state.userData.id,
            },
            JSON.parse(sessionStorage.getItem('USERDATA')).token
          )
          .then(res => res.json())
          .then(result => {
            console.log('result233', result)
            if (result.ret === 200) {
              message.success(intl.get('XIUGAICHNGGONG'))
              this.setState(
                {
                  editVisible: false,
                },
                () => {
                  this.reflash()
                }
              )
            }
          })
        break
      case 3:
        person
          .updaeCus(
            {
              email: this.state.editData,
              id: this.state.userData.id,
            },
            JSON.parse(sessionStorage.getItem('USERDATA')).token
          )
          .then(res => res.json())
          .then(result => {
            console.log('result233', result)
            if (result.ret === 200) {
              message.success(intl.get('XIUGAICHNGGONG'))
              this.setState(
                {
                  editVisible: false,
                },
                () => {
                  this.reflash()
                }
              )
            }
          })
        break
      case 4:
        person
          .updaeCus(
            {
              phone: this.state.editData,
              id: this.state.userData.id,
            },
            JSON.parse(sessionStorage.getItem('USERDATA')).token
          )
          .then(res => res.json())
          .then(result => {
            console.log('result233', result)
            if (result.ret === 200) {
              message.success(intl.get('XIUGAICHNGGONG'))
              this.setState(
                {
                  editVisible: false,
                },
                () => {
                  this.reflash()
                }
              )
            }
          })
        break

      case 5:
        if (this.state.nowpassword !== this.state.userpassword) {
          message.warning(intl.get('LIANGCISHURUMIMABUZHENQUE'))
          return
        }
        person
          .updaeCus(
            {
              passwd: this.state.userpassword,
              id: this.state.userData.id,
            },
            JSON.parse(sessionStorage.getItem('USERDATA')).token
          )
          .then(res => res.json())
          .then(result => {
            console.log('result233', result)
            if (result.ret === 200) {
              message.success(intl.get('XIUGAICHNGGONG'))
              this.setState(
                {
                  editVisible: false,
                },
                () => {
                  this.getUser()
                }
              )
            }
          })
        break
      case 6:
        console.log('')
        person
          .updaeCus(
            {
              wechat: this.state.editData,
              id: this.state.userData.id,
            },
            JSON.parse(sessionStorage.getItem('USERDATA')).token
          )
          .then(res => res.json())
          .then(result => {
            console.log('result233', result)
            if (result.ret === 200) {
              message.success(intl.get('XIUGAICHNGGONG'))
              this.setState(
                {
                  editVisible: false,
                },
                () => {
                  this.getUser()
                }
              )
            }
          })
        break
      default:
        break
    }
  }

  handleCancel = () => {
    this.setState({
      editVisible: false,
    })
  }

  getShopData = () => {
    merchantsInfo
      .merchantsInfoListWeb({
        language: sessionStorage['language'],
        phone: this.state.userData.phone,
        pageSize: 10,
        pageNum: 1,
      })
      .then(res => res.json())
      .then(result => {
        console.log('result', result)
        if (result.ret === 200 && this.state.userData.phone) {
          this.setState({
            myShopData: result.data?.list,
          })
        } else {
          this.setState({
            myShopData: [],
          })
        }
      })
  }

  showShopTab = () => {
    if (this.state.userData?.isMerchants !== 2) {
      return (
        <>
          <div
            className={
              this.state.checkedtap === 1
                ? 'my_place_tabs_item my_place_tabs_item_active'
                : 'my_place_tabs_item'
            }
            onClick={this.handleChangeTab.bind(this, 1)}
          >
            {intl.get('DIANPUSHOUC')}
          </div>
          <div
            className={
              this.state.checkedtap === 2
                ? 'my_place_tabs_item my_place_tabs_item_active'
                : 'my_place_tabs_item'
            }
            onClick={this.handleChangeTab.bind(this, 2)}
          >
            {intl.get('TIEZHISHOUCHANG')}
          </div>
          <div
            className={
              this.state.checkedtap === 3
                ? 'my_place_tabs_item my_place_tabs_item_active'
                : 'my_place_tabs_item'
            }
            onClick={this.handleChangeTab.bind(this, 3)}
          >
            {intl.get('YIFATIEZHIE')}
          </div>
          <div
            className={
              this.state.checkedtap === 4
                ? 'my_place_tabs_item my_place_tabs_item_active'
                : 'my_place_tabs_item'
            }
            onClick={this.handleChangeTab.bind(this, 4)}
          >
            {intl.get('XIAOXIZHONGXIN')}
          </div>
        </>
      )
    } else {
      return (
        <>
          <div
            className={
              this.state.checkedtap === 6
                ? 'my_place_tabs_item my_place_tabs_item_active'
                : 'my_place_tabs_item'
            }
            onClick={this.handleChangeTab.bind(this, 6)}
          >
            {intl.get('SHANGJIADIANPU')}
          </div>
          <div
            className={
              this.state.checkedtap === 3
                ? 'my_place_tabs_item my_place_tabs_item_active'
                : 'my_place_tabs_item'
            }
            onClick={this.handleChangeTab.bind(this, 3)}
          >
            {intl.get('TIEZHIZHONGXIN')}
          </div>
          <div
            className={
              this.state.checkedtap === 4
                ? 'my_place_tabs_item my_place_tabs_item_active'
                : 'my_place_tabs_item'
            }
            onClick={this.handleChangeTab.bind(this, 4)}
          >
            {intl.get('XIAOXIZHONGXIN')}
          </div>
        </>
      )
    }
  }

  InfiniteScrollContent = () => {
    return (
      <>
        {this.state.hasMore ? (
          <>
            <span>Loading</span>
            <Loading />
          </>
        ) : (
          <span>--- {intl.get('ZUIHOUYITIAO')} ---</span>
        )}
      </>
    )
  }

  loadMore = async () => {
    let res = await forum.forumListWeb({
      customerId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
      pageSize: this.state.postBbsPageSize,
      pageNum: this.state.postBbsPageNum,
    })
    let result = await res.json()
    console.log('1212', 1212)
    let arr = []
    arr = this.state.postBbsData
    if (
      result.ret === 200 &&
      this.state.postBbsPageNum * this.state.postBbsPageSize <
        result.data.totalCount
    ) {
      this.setState({
        postBbsPageNum: this.state.postBbsPageNum + 1,
        postBbsTotal: result.data.totalCount,
        postBbsData: [...arr, ...result.data.list],
      })
    } else {
      this.setState({
        hasMore: false,
      })
    }
  }

  // 帖子收藏
  InfiniteScrollContent2 = () => {
    return (
      <>
        {this.state.hasMore2 ? (
          <>
            <span>Loading</span>
            <Loading />
          </>
        ) : (
          <span>--- {intl.get('ZUIHOUYITIAO')} ---</span>
        )}
      </>
    )
  }

  loadMore2 = async () => {
    let res = await person.myForumwebCollectList(
      {
        customerId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        pageSize: this.state.bbsPageSize,
        pageNum: this.state.bbsPageNum,
      },
      JSON.parse(sessionStorage.getItem('USERDATA'))?.token
    )
    let result = await res.json()
    console.log('1212', 1212)
    let arr = []
    arr = this.state.bbsData
    if (
      result.ret === 200 &&
      this.state.bbsPageNum * this.state.pageSize < result.data.totalCount
    ) {
      this.setState({
        bbsPageNum: this.state.bbsPageNum + 1,
        bbsTotal: result.data.totalCount,
        bbsData: [...arr, ...result.data.list],
      })
    } else {
      this.setState({
        hasMore2: false,
      })
    }
  }

  // 店铺收藏
  InfiniteScrollContent3 = () => {
    return (
      <>
        {this.state.hasMore3 ? (
          <>
            <span>Loading</span>
            <Loading />
          </>
        ) : (
          <span>--- {intl.get('ZUIHOUYITIAO')} ---</span>
        )}
      </>
    )
  }

  loadMore3 = async () => {
    let res = await person.myCollectList(
      {
        customerId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        language: sessionStorage['language'],
        categoryId: this.state.selectCategory,
        pageSize: this.state.shopPageSize,
        pageNum: this.state.shopPageNum,
      },
      JSON.parse(sessionStorage.getItem('USERDATA'))?.token
    )
    let result = await res.json()
    console.log('1212', 1212)
    let arr = []
    arr = this.state.shopData
    if (
      result.ret === 200 &&
      this.state.shopPageNum * this.state.pageSize < result.data.totalCount
    ) {
      this.setState({
        shopPageNum: this.state.shopPageNum + 1,
        shopTotal: result.data.totalCount,
        shopData: [...arr, ...result.data.list],
      })
    } else {
      this.setState({
        hasMore3: false,
      })
    }
  }

  switchTab = val => {
    console.log('val', val)
    this.setState({
      clickKey: val,
    })
  }

  handleOut = () => {
    sessionStorage.removeItem('USERDATA')
    this.props.history.push('/main')
  }

  switchContent = () => {
    switch (this.state.clickKey) {
      case 1:
        return (
          <>
            <div className="phone_person_content_tabs_content_item">
              <div className="phone_person_content_tabs_content_item_left">
                {intl.get('ZHANGHAO')}
              </div>
              <div className="phone_person_content_tabs_content_item_right">
                {this.state.userData?.account}
              </div>
            </div>
            <div className="phone_person_content_tabs_content_item">
              <div className="phone_person_content_tabs_content_item_left">
                {intl.get('XINGMIMIGHN')}
              </div>
              <div className="phone_person_content_tabs_content_item_right">
                {this.state.userData?.personName}
              </div>
            </div>
            <div className="phone_person_content_tabs_content_item">
              <div className="phone_person_content_tabs_content_item_left">
                {intl.get('SHOUJIHAOMA')}
              </div>
              <div className="phone_person_content_tabs_content_item_right">
                {this.state.userData?.phone}
              </div>
            </div>
            <div className="phone_person_content_tabs_content_item">
              <div className="phone_person_content_tabs_content_item_left">
                {intl.get('WEIXINHAO')}
              </div>
              <div className="phone_person_content_tabs_content_item_right">
                {this.state.userData?.wechat}
              </div>
            </div>
            <div className="phone_person_content_tabs_content_item">
              <div className="phone_person_content_tabs_content_item_left">
                {intl.get('YOUXIANG')}
              </div>
              <div className="phone_person_content_tabs_content_item_right">
                {this.state.userData?.email}
              </div>
            </div>
            <div className="loginOut" onClick={this.handleOut}>
              {intl.get('TUICHUDENGLU')}
            </div>
          </>
        )
      case 2:
        return (
          <>
            {this.state.postBbsData.map((item, index) => {
              return (
                <div className="phone_content_item" key={index}>
                  <div className="phone_content_item_top">
                    <Avatar
                      size={30}
                      icon={<UserOutlined />}
                      src={item.customerPath}
                    />
                    <div
                      className="phone_content_item_title"
                      onClick={this.handleToDetail.bind(this, item.id)}
                    >
                      <div className="phone_content_item_title_text">
                        {item.customerName}
                      </div>
                      <div className="phone_content_item_title_time">
                        {' '}
                        -- {item.createDate}
                      </div>
                    </div>

                    <div className="phone_content_item_tag">
                      <div className="phone_content_item_tag_btn_none">
                        <EditOutlined
                          style={{ marginRight: '15px' }}
                          onClick={this.handleToEditDetail.bind(this, item)}
                        />
                        <RestOutlined
                          onClick={this.handleToDelete.bind(this, item)}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="phone_content_item_title_text"
                    onClick={this.handleToDetail.bind(this, item.id)}
                  >
                    {item.mainTitle}
                  </div>
                  <div
                    className="phone_content_item_context"
                    dangerouslySetInnerHTML={{ __html: item.context }}
                  ></div>

                  <span
                    className="see_more"
                    onClick={this.handleToDetail.bind(this, item.id)}
                  >
                    {'....' + intl.get('CHAKANGENGDUO')}
                  </span>
                </div>
              )
            })}

            <InfiniteScroll
              loadMore={this.loadMore}
              hasMore={this.state.hasMore}
              threshold={0}
            >
              {this.InfiniteScrollContent()}
            </InfiniteScroll>
          </>
        )

      case 3:
        return (
          <>
            {this.state.bbsData.map(item => {
              return (
                <div
                  className="phone_content_item"
                  key={item.id}
                  onClick={this.handleToDetail.bind(this, item.id)}
                >
                  <div className="phone_content_item_top">
                    <Avatar
                      size={30}
                      icon={<UserOutlined />}
                      src={item.customerPath}
                    />
                    <div className="phone_content_item_title">
                      <div className="phone_content_item_title_text">
                        {item.customerName}
                      </div>
                      <div className="phone_content_item_title_time">
                        {' '}
                        -- {item.createDate}
                      </div>
                    </div>

                    <div className="phone_content_item_tag">
                      <div className="phone_content_item_tag_btn_none">
                        {/* <EditOutlined /> */}
                      </div>
                    </div>
                  </div>
                  <div className="phone_content_item_title_text">
                    {item.mainTitle}
                  </div>
                  <div
                    className="phone_content_item_context"
                    dangerouslySetInnerHTML={{ __html: item.context }}
                  ></div>

                  <span className="see_more">
                    {'....' + intl.get('CHAKANGENGDUO')}
                  </span>
                </div>
              )
            })}

            <InfiniteScroll
              loadMore={this.loadMore2}
              hasMore={this.state.hasMore2}
              threshold={0}
            >
              {this.InfiniteScrollContent2()}
            </InfiniteScroll>
          </>
        )
      case 4:
        return (
          <>
            {this.state.shopData.map(item => {
              return (
                <div
                  className="shop_content"
                  key={item.id}
                  onClick={this.goToDetail.bind(this, item.id)}
                >
                  <div className="shop_content_left">
                    <Image
                      width={'8rem'}
                      height={'8rem'}
                      src={item.path ? item.path.split(',')[0] : ''}
                      fallback="data:image/png;base64,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"
                      preview={false}
                      style={{ borderRadius: '10px 10px 10px 10px' }}
                    />
                  </div>
                  <div className="shop_content_right">
                    <div className="shop_content_right_title">
                      <span className="shop_content_right_title_name">
                        {item.merchantsName}
                      </span>{' '}
                    </div>
                    <div className="shop_content_right_item">
                      <TagOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.tags}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <EnvironmentOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.address}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <PhoneOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.phone}
                      </span>
                    </div>
                    <div className="shop_content_right_item">
                      <GlobalOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.webAddress}
                      </span>
                    </div>
                  </div>
                </div>
              )
            })}

            <InfiniteScroll
              loadMore={this.loadMore3}
              hasMore={this.state.hasMore3}
              threshold={0}
            >
              {this.InfiniteScrollContent3()}
            </InfiniteScroll>
          </>
        )
      case 5:
        return (
          <>
            {this.state.myShopData.map(item => {
              return (
                <div
                  className="shop_content"
                  key={item.id}
                  onClick={this.goToDetail.bind(this, item.id)}
                >
                  <div className="shop_content_left">
                    <Image
                      width={'8rem'}
                      height={'8rem'}
                      src={item.path ? item.path.split(',')[0] : ''}
                      fallback="data:image/png;base64,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"
                      preview={false}
                      style={{ borderRadius: '10px 10px 10px 10px' }}
                    />
                  </div>
                  <div className="shop_content_right">
                    <div className="shop_content_right_title">
                      <span className="shop_content_right_title_name">
                        {item.merchantsName}
                      </span>{' '}
                    </div>
                    <div className="shop_content_right_item">
                      <TagOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.tags}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <EnvironmentOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.address}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <PhoneOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.phone}
                      </span>
                    </div>

                    <div className="shop_content_right_item">
                      <GlobalOutlined style={{ color: '#42d8d9' }} />
                      <span className="shop_content_right_item_title">
                        {item.webAddress}
                      </span>
                    </div>
                  </div>
                </div>
              )
            })}

            <InfiniteScroll
              loadMore={this.loadMore3}
              hasMore={this.state.hasMore3}
              threshold={0}
            >
              {this.InfiniteScrollContent3()}
            </InfiniteScroll>
          </>
        )
      default:
        break
    }
  }

  handleEditPhone = () => {
    this.setState({
      visible: true,
    })
  }

  handleBack = () => {
    this.props.history.goBack()
  }

  judgeContent = () => {
    switch (this.state.checkedtap) {
      case 1:
        return (
          <div className="my_place_content">
            <div className="my_place_content_left">
              <div className="my_place_content_left_title">
                {intl.get('FENLEI')}
              </div>
              <div className="my_place_content_left_content">
                {this.state.shopCategorys.map(item => {
                  return (
                    <div
                      className={
                        this.state.selectCategory === item.id
                          ? 'my_place_content_left_content_item my_place_content_left_content_item_active '
                          : 'my_place_content_left_content_item customer_hover'
                      }
                      key={item.id}
                      onClick={this.handleSelect.bind(this, item.id)}
                    >
                      {item.columnName}
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="my_place_content_right">
              {this.state.shopData.map(item => {
                return (
                  <div
                    className="my_place_content_right_item"
                    key={item.id}
                    onClick={this.goToDetail.bind(this, item.id)}
                  >
                    <div className="my_place_content_right_item_title">
                      <div className="my_place_content_right_item_maintitle">
                        {item.merchantsName}
                      </div>
                      <div className="my_place_content_right_item_subtitle">
                        {item.tags}
                      </div>
                    </div>
                    <div className="my_place_content_right_item_content">
                      <div className="my_place_content_right_item_content_left">
                        <Image
                          width="2.32rem"
                          height="1.68rem"
                          preview={false}
                          src={item.path ? item.path.split(',')[0] : ''}
                          fallback="data:image/png;base64,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"
                        />
                      </div>

                      <div className="my_place_content_right_item_content_right">
                        <div className="my_place_content_right_item_content_right_item">
                          {' '}
                          <PhoneOutlined
                            style={{ color: '#18b2b0', paddingRight: '0.1rem' }}
                          />
                          {item.phone}
                        </div>
                        <div className="my_place_content_right_item_content_right_item">
                          {' '}
                          <EnvironmentOutlined
                            style={{ color: '#18b2b0', paddingRight: '0.1rem' }}
                          />
                          {item.address}
                        </div>
                        <div className="my_place_content_right_item_content_right_item">
                          <MailOutlined
                            style={{ color: '#18b2b0', paddingRight: '0.1rem' }}
                          />
                          {item.email}
                        </div>
                        <div className="my_place_content_right_item_content_right_item">
                          <NodeIndexOutlined
                            style={{ color: '#18b2b0', paddingRight: '0.1rem' }}
                          />
                          {item.webAddress}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
              <div className="my_place_content_right_pagion">
                <APagination
                  pageNum={this.state.shopPageNum}
                  total={this.state.shopTotal}
                  current={this.state.shopPageNum}
                  changePage={this.handleChangeShopPage}
                />
              </div>
            </div>
          </div>
        )
      case 2:
        return (
          <div className="my_place_content_other">
            <div className="my_place_content_title">
              <div className="my_place_content_title_item">
                {' '}
                {intl.get('FABURIQI')}
              </div>
              <div className="my_place_content_title_item">
                {intl.get('FABUSHIJIAN')}
              </div>
            </div>
            <div className="my_place_content_list">
              {this.state.bbsData.map(item => {
                return (
                  <div
                    className="my_place_content_list_item"
                    key={item.id}
                    onClick={this.handleToDetail.bind(this, item.id)}
                  >
                    <div className="my_place_content_list_item_title">
                      {item.mainTitle}
                      {this.weatherPath(item)}
                    </div>
                    <div className="my_place_content_list_item_text">
                      <div className="my_place_content_list_item_text_item">
                        <span className="my_place_content_list_item_text_item_content">
                          {' '}
                          <EyeOutlined
                            style={{
                              color: '#18b2b0',
                              paddingRight: '0.08rem',
                            }}
                          />
                          {intl.get('LIULAN')}：{item.clickNum}
                        </span>
                        <span>
                          {' '}
                          <MessageOutlined
                            style={{
                              color: '#18b2b0',
                              paddingRight: '0.08rem',
                            }}
                          />
                          {intl.get('PINGLUN')}：{item.replyNum}
                        </span>
                      </div>
                      <div className="my_place_content_list_item_text_item">
                        <span className="my_place_content_list_item_text_item_content">
                          {item.createDate?.substring(0, 10)}
                        </span>
                        <span>{item.createDate?.substring(10, 19)}</span>
                      </div>
                    </div>
                  </div>
                )
              })}

              <div className="my_place_content_right_pagion">
                <APagination
                  pageNum={this.state.bbsPageNum}
                  total={this.state.bbsTotal}
                  current={this.state.bbsPageNum}
                  changePage={this.handleChangeBbsPage}
                />
              </div>
            </div>
          </div>
        )
      case 3:
        return (
          <div className="my_place_content_other">
            <div className="my_place_content_title">
              <div className="my_place_content_title_item">
                {' '}
                {intl.get('FABURIQI')}
              </div>
              <div className="my_place_content_title_item">
                {intl.get('FABUSHIJIAN')}
              </div>
            </div>

            <div className="my_place_content_list">
              {this.state.postBbsData.map(item => {
                return (
                  <div className="my_place_content_list_item" key={item.id}>
                    <div className="my_place_content_list_item_title">
                      <div
                        className="my_place_content_list_item_title_item"
                        onClick={this.handleToDetail.bind(this, item.id)}
                      >
                        {item.mainTitle}
                        {this.weatherPath(item)}
                      </div>

                      <div className="my_place_content_list_item_edit">
                        <EditOutlined
                          style={{ marginRight: '0.15rem' }}
                          onClick={this.handleToEditDetail.bind(this, item)}
                        />

                        <RestOutlined
                          onClick={this.handleToDelete.bind(this, item)}
                        />
                      </div>
                    </div>
                    <div
                      className="my_place_content_list_item_text"
                      onClick={this.handleToDetail.bind(this, item.id)}
                    >
                      <div className="my_place_content_list_item_text_item">
                        <span className="my_place_content_list_item_text_item_content">
                          {' '}
                          <EyeOutlined
                            style={{
                              color: '#18b2b0',
                              paddingRight: '0.08rem',
                            }}
                          />
                          {intl.get('LIULAN')}：{item.clickNum}
                        </span>
                        <span>
                          {' '}
                          <MessageOutlined
                            style={{
                              color: '#18b2b0',
                              paddingRight: '0.08rem',
                            }}
                          />
                          {intl.get('PINGLUN')}：{item.replyNum}
                        </span>
                      </div>
                      <div className="my_place_content_list_item_text_item">
                        <span className="my_place_content_list_item_text_item_content">
                          {item.createDate?.substring(0, 10)}
                        </span>
                        <span>{item.createDate?.substring(10, 19)}</span>
                      </div>
                    </div>
                  </div>
                )
              })}

              <div className="my_place_content_right_pagion">
                <APagination
                  pageNum={this.state.postBbsPageNum}
                  total={this.state.postBbsTotal}
                  current={this.state.postBbsPageNum}
                  changePage={this.handleChangePostBbsPage}
                />
              </div>
            </div>
          </div>
        )
      case 4:
        return (
          <div className="people_message">
            <div className="people_message_left">
              <div className="people_message_left_top">
                {' '}
                <NotificationFilled
                  style={{
                    color: '#000',
                    paddingRight: '0.08rem',
                    fontSize: '0.16rem',
                  }}
                />
                {intl.get('XITONGTONGZHI')}
              </div>
              {this.state.chatData.map(item => {
                if (
                  item.userId ===
                    JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
                      .id &&
                  item.chatRecords.length !== 0
                ) {
                  return (
                    <div
                      className={
                        this.state.chooseKey === item.id
                          ? 'people_message_left_item_active'
                          : 'people_message_left_item'
                      }
                      onClick={this.chooseChat.bind(this, item)}
                    >
                      <Avatar
                        icon={<UserOutlined />}
                        src={item.memberPath}
                        key={item.id}
                      />
                      <span className="people_message_left_item_text">
                        {item.memberName}
                      </span>
                    </div>
                  )
                } else {
                  return (
                    <div
                      className={
                        this.state.chooseKey === item.id
                          ? 'people_message_left_item_active'
                          : 'people_message_left_item'
                      }
                      onClick={this.chooseChat.bind(this, item)}
                    >
                      <Avatar
                        icon={<UserOutlined />}
                        src={item.userPath}
                        key={item.id}
                      />
                      <span className="people_message_left_item_text">
                        {item.shopUserName}
                      </span>
                    </div>
                  )
                }
              })}
            </div>
            <div className="people_message_right">
              <div className="people_message_right_message" id="contentmessage">
                {this.chatContent()}
              </div>

              <div className="people_message_right_send_message">
                {/* <TextArea rows={6} value={this.state.liveMessage} onChange={this.handleChangeMessage} onPressEnter={this.handleSendMessage} /> */}
                <BraftEditor
                  className="sendMesage_editor"
                  controls={controls}
                  placeholder="請輸入店鋪介紹"
                  value={this.state.liveMessage}
                  onChange={this.handleChangeMessage}
                />
                <div className="people_message_right_send_message_btn">
                  {' '}
                  <Button type="primary" onClick={this.handleSendMessage}>
                    {intl.get('FASONG')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )
      case 5:
        return (
          <div className="people_setting">
            <div className="people_setting_title">{intl.get('SHEZHI')}</div>

            <div className="people_setting_item">
              <div className="people_setting_item_left">
                <Avatar
                  size={{ xs: 36, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
                  src={this.state.userData.path}
                  icon={<UserOutlined />}
                />
              </div>
              <ImgCrop>
                <Upload
                  action={
                    process.env.REACT_APP_UPLOAD_API +
                    '/website/upload/uploadpic'
                  }
                  showUploadList={false}
                  fileList={this.state.fileList}
                  onPreview={this.handlePreview}
                  onChange={this.handleChange}
                  data={this.state.mainpathparms}
                  headers={this.state.headers}
                >
                  <div className="people_setting_item_right">
                    {' '}
                    {intl.get('SHANGHCUANGTOUXIANG')}
                  </div>
                </Upload>
              </ImgCrop>
            </div>
            <div className="people_setting_item">
              <div className="people_setting_item_left">
                {intl.get('ZHANGHAO')}：{this.state.userData.account}
              </div>
            </div>
            <div className="people_setting_item">
              <div className="people_setting_item_left">
                {intl.get('XINGMIMIGHN')}： {this.state.userData.personName}
              </div>
              <div
                className="people_setting_item_right"
                onClick={this.handleEdit.bind(this, 2)}
              >
                {' '}
                {intl.get('XIUGAI')}
              </div>
            </div>

            <div className="people_setting_item">
              <div className="people_setting_item_left">
                {intl.get('YOUXIANG')}：{this.state.userData.email}
              </div>
              <div
                className="people_setting_item_right"
                onClick={this.handleEdit.bind(this, 3)}
              >
                {intl.get('XIUGAI')}
              </div>
            </div>
            <div className="people_setting_item">
              <div className="people_setting_item_left">
                {intl.get('SHOUJIHAOMA')}：{this.state.userData.phone}
              </div>
              <div
                className="people_setting_item_right"
                onClick={this.handleEdit.bind(this, 4)}
              >
                {intl.get('XIUGAI')}
              </div>
            </div>
            <div className="people_setting_item">
              <div className="people_setting_item_left">
                {intl.get('WEIXINHAO')}：{this.state.userData.wechat}
              </div>
              <div
                className="people_setting_item_right"
                onClick={this.handleEdit.bind(this, 6)}
              >
                {intl.get('XIUGAI')}
              </div>
            </div>
            <div className="people_setting_item">
              <div className="people_setting_item_left">
                {intl.get('DENGLUMIMA')}：************
              </div>
              <div
                className="people_setting_item_right"
                onClick={this.handleEdit.bind(this, 5)}
              >
                {intl.get('XIUGAI')}
              </div>
            </div>

            <Modal
              title={this.state.editTitle}
              visible={this.state.editVisible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
            >
              {this.diffComponent()}
            </Modal>
          </div>
        )

      case 6:
        return (
          <div className="my_place_content">
            <div className="shop_place_content_right">
              {this.state.myShopData.map(item => {
                return (
                  <div
                    className="my_place_content_right_item"
                    key={item.id}
                    onClick={this.goToDetail.bind(this, item.id)}
                  >
                    <div className="my_place_content_right_item_title">
                      <div className="my_place_content_right_item_maintitle">
                        {item.merchantsName}
                      </div>
                      <div className="my_place_content_right_item_subtitle">
                        {item.tags}
                      </div>
                    </div>
                    <div className="my_place_content_right_item_content">
                      <div className="my_place_content_right_item_content_left">
                        <Image
                          width="2.32rem"
                          height="1.68rem"
                          preview={false}
                          src={item.path ? item.path.split(',')[0] : ''}
                          fallback="data:image/png;base64,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"
                        />
                      </div>
                    </div>
                    <div className="shop_content_list_item_text_item">
                      <span className="my_place_content_list_item_text_item_content">
                        {' '}
                        <EyeOutlined
                          style={{ color: '#18b2b0', paddingRight: '0.08rem' }}
                        />
                        {intl.get('LIULAN')}：{item.clickNum}
                      </span>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )
      default:
        break
    }
  }

  phoneShowShopTab = () => {
    if (this.state.userData?.isMerchants !== 2) {
      return (
        <>
          <div
            className={
              this.state.clickKey === 1
                ? 'phone_person_content_tab_active'
                : 'phone_person_content_tab'
            }
            onClick={this.switchTab.bind(this, 1)}
          >
            {intl.get('ZHUYE')}
          </div>
          <div
            className={
              this.state.clickKey === 2
                ? 'phone_person_content_tab_active'
                : 'phone_person_content_tab'
            }
            onClick={this.switchTab.bind(this, 2)}
          >
            {intl.get('YIFATIEZHIE')}
          </div>
          <div
            className={
              this.state.clickKey === 3
                ? 'phone_person_content_tab_active'
                : 'phone_person_content_tab'
            }
            onClick={this.switchTab.bind(this, 3)}
          >
            {intl.get('TIEZHESHOUCHANG')}
          </div>
          <div
            className={
              this.state.clickKey === 4
                ? 'phone_person_content_tab_active'
                : 'phone_person_content_tab'
            }
            onClick={this.switchTab.bind(this, 4)}
          >
            {intl.get('DIANPUSHOUC')}
          </div>
        </>
      )
    } else {
      return (
        <>
          <div
            className={
              this.state.clickKey === 1
                ? 'phone_person_content_tab_active'
                : 'phone_person_content_tab'
            }
            onClick={this.switchTab.bind(this, 1)}
          >
            {intl.get('ZHUYE')}
          </div>
          <div
            className={
              this.state.clickKey === 2
                ? 'phone_person_content_tab_active'
                : 'phone_person_content_tab'
            }
            onClick={this.switchTab.bind(this, 2)}
          >
            {intl.get('YIFATIEZHIE')}
          </div>
          <div
            className={
              this.state.clickKey === 5
                ? 'phone_person_content_tab_active'
                : 'phone_person_content_tab'
            }
            onClick={this.switchTab.bind(this, 5)}
          >
            {intl.get('SHANGJIADIANPU')}
          </div>
        </>
      )
    }
  }

  // 即时通讯

  chooseChat = item => {
    console.log('item', item)
    this.setState(
      {
        chooseKey: item.id,
        chatItem: item,
      },
      () => {
        var div = document.getElementById('contentmessage')
        div.scrollTop = div.scrollHeight
      }
    )
  }
  chatContent = () => {
    if (this.state.userData.isMerchants === 2) {
      // 商家账号登录
      return this.state.chatItem?.chatRecords?.map((item, index) => {
        if (
          item.userId ===
          JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id
        ) {
          return (
            <div key={index} style={{ paddingTop: '0.3rem' }}>
              {((index / 10) | 0) === index / 10 ? (
                <div className="message_time">{item.time}</div>
              ) : (
                ''
              )}

              <div className="people_message_right_message_right">
                <div className="people_message_right_message_right_name">
                  {item.userName}：
                </div>
                <div className="people_message_right_message_right_text">
                  <span
                    className="people_message_right_message_right_text_content"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  ></span>
                </div>
              </div>
            </div>
          )
        } else {
          return (
            <div key={index} style={{ paddingTop: '0.3rem' }}>
              <div className="people_message_right_message_left">
                <div className="people_message_right_message_left_name">
                  {item.memberName}：
                </div>
                <div className="people_message_right_message_left_text">
                  <span
                    className="people_message_right_message_left_text_content"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  ></span>
                </div>
              </div>
            </div>
          )
        }
      })
    } else {
      return this.state.chatItem?.chatRecords?.map((item, index) => {
        if (
          item.memberId ===
          JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id
        ) {
          return (
            <div key={index} style={{ paddingTop: '0.3rem' }}>
              {((index / 10) | 0) === index / 10 ? (
                <div className="message_time">{item.time}</div>
              ) : (
                ''
              )}

              <div className="people_message_right_message_right">
                <div className="people_message_right_message_right_name">
                  {item.memberName}：
                </div>
                <div className="people_message_right_message_right_text">
                  <span
                    className="people_message_right_message_right_text_content"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  ></span>
                </div>
              </div>
            </div>
          )
        } else {
          return (
            <div key={index} style={{ paddingTop: '0.3rem' }}>
              <div className="people_message_right_message_left">
                <div className="people_message_right_message_left_name">
                  {item.userName}：
                </div>
                <div
                  className="people_message_right_message_left_text"
                  dangerouslySetInnerHTML={{ __html: item.content }}
                ></div>
              </div>
            </div>
          )
        }
      })
    }
  }

  getHistory = () => {
    if (
      JSON.parse(sessionStorage.getItem('USERDATA'))?.customer?.isMerchants ===
      0
    ) {
      CHAT.queryFrame(
        {
          memberId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        },
        JSON.parse(sessionStorage.getItem('USERDATA'))?.token
      )
        .then(res => res.json())
        .then(result => {
          console.log('result', result)
          if (result.ret === 200 && result.data.content.length !== 0) {
            this.setState({
              chatData: result.data.content,
            })
          } else {
            this.setState({
              chatData: [
                {
                  chatRecords: [],
                },
              ],
            })
          }
        })
    } else {
      CHAT.queryFrame(
        {
          userId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        },
        JSON.parse(sessionStorage.getItem('USERDATA'))?.token
      )
        .then(res => res.json())
        .then(result => {
          console.log('result', result)
          if (result.ret === 200 && result.data.content.length !== 0) {
            this.setState({
              chatData: result.data.content,
            })
          } else {
            this.setState({
              chatData: [
                {
                  chatRecords: [],
                },
              ],
            })
          }
        })
    }
  }

  onMessage = e => {
    console.log('message', e)
    // let allmessage = this.state.chatData
    let arr = this.state.chatItem
    let objmessage = JSON.parse(e)
    console.log('arr.memberId', arr.memberId)
    console.log('objmessage.memberId', objmessage.memberId)
    console.log('chatData', this.state.chatData)

    if (
      arr.memberId === objmessage.memberId ||
      arr.userId === objmessage.userId
    ) {
      arr.chatRecords?.push(objmessage)
    }
    // for (let i in allmessage) {
    //     if (allmessage[i].memberId === objmessage.memberId || allmessage[i].userId === objmessage.userId) {
    //         allmessage[i].chatRecords?.push(objmessage)
    //     }
    // }

    this.setState({}, () => {
      var div = document.getElementById('contentmessage')
      div.scrollTop = div.scrollHeight
    })
  }

  onClose = e => {
    console.log('close', e)
  }

  onOpen = e => {
    console.log('open', e)
    console.log('this.refWebSocket', this.refWebSocket)
  }

  handleChangeMessage = e => {
    this.setState({
      liveMessage: e,
    })
  }

  handleSendMessage = e => {
    let sendMessage = this.state.liveMessage.toHTML()
    sendMessage = sendMessage.replace(/\s/g, '')
    if (sendMessage === '' || sendMessage === '<p></p>') {
      message.warning(intl.get('QINGSHURUNEIRONG'))
      return false
    }

    // 普通客户回复商家
    if (
      JSON.parse(sessionStorage.getItem('USERDATA'))?.customer?.isMerchants ===
      0
    ) {
      let willmessage = {
        memberId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        memberName: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
          .account,
        content: this.state.liveMessage.toHTML(),
        shopUserId: this.state.chatItem.userId,
        shopUserName: this.state.chatItem.userName,
      }
      // message : {
      //  memberId;  用户id
      //  memberName;用户名
      //  userId; 商家用户id
      //  userName;商家用户名
      //  content; 聊天数据
      //  shopUserId (用户发商家需要, shopUserData商家用户id )
      // shopUserName (用户发商家需要, shopUserData商家用户名字 )
      // }
      let arr = this.state.chatItem
      let objmessage = {
        content: this.state.liveMessage.toHTML(),
        memberId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        memberName: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
          .account,
        shopUserId: this.state.chatItem.userId,
        shopUserName: this.state.chatItem.userName,
      }
      arr.chatRecords.push(objmessage)
      this.refWebSocket.refWebSocket.sendMessage(JSON.stringify(willmessage))
      this.setState(
        {
          liveMessage: BraftEditor.createEditorState(),
        },
        () => {
          var div = document.getElementById('contentmessage')
          console.log('div', div)
          div.scrollTop = div.scrollHeight
        }
      )
    } else {
      console.log('this.state.chatItem=====>', this.state.chatItem)
      // 商家回复普通客户
      let willmessage = {
        userId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        userName: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
          .account,
        content: this.state.liveMessage.toHTML(),
        frameId: this.state.chatItem.chatRecords[0].frameId,
      }
      // message : {
      //  memberId;  用户id
      //  memberName;用户名
      //  userId; 商家用户id
      //  userName;商家用户名
      //  content; 聊天数据
      //  shopUserId (用户发商家需要, shopUserData商家用户id )
      // shopUserName (用户发商家需要, shopUserData商家用户名字 )
      // }
      let arr = this.state.chatItem
      let objmessage = {
        content: this.state.liveMessage.toHTML(),
        userId: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
        userName: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
          .account,
        frameId: this.state.chatItem.chatRecords[0].frameId,
      }
      arr.chatRecords.push(objmessage)
      this.refWebSocket.refWebSocket.sendMessage(JSON.stringify(willmessage))
      this.setState(
        {
          liveMessage: BraftEditor.createEditorState(),
        },
        () => {
          var div = document.getElementById('contentmessage')
          console.log('div', div)
          div.scrollTop = div.scrollHeight
        }
      )
    }
  }

  handleGoIndex = () => {
    this.props.history.push({ pathname: '/main' })
  }

  render() {
    document.title = 'EQLD昆士兰易搜-专注服务昆州本地社区'
    document
      .querySelector('meta[property="og:title"]')
      .setAttribute('content', 'EQLD昆士兰易搜')
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute('content', '专注服务昆州本地社区')
    document
      .querySelector('meta[itemprop="description"]')
      .setAttribute('content', '专注服务昆州本地社区')
    document
      .querySelector('meta[property="og:type"]')
      .setAttribute('content', 'website')
    document
      .querySelector('meta[property="og:image"]')
      .setAttribute(
        'content',
        'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png'
      )
    document
      .querySelector('meta[itemprop="image"]')
      .setAttribute(
        'content',
        'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png'
      )
    document
      .querySelector('meta[itemprop="name"]')
      .setAttribute('content', '专注服务昆州本地社区')

    const obj = {
      user_id: JSON.parse(sessionStorage.getItem('USERDATA'))?.customer.id,
      user_type:
        JSON.parse(sessionStorage.getItem('USERDATA'))?.customer
          ?.isMerchants === 2
          ? 1
          : 2, // 1商家， 2普通客户
    }
    let webSocketUrl =
      'wss://' +
      process.env.REACT_APP_WEBSOCKET_API +
      '/website/websocket?msg=' +
      encodeURI(JSON.stringify(obj))
    return (
      <>
        <div className="main_content">
          <Modal
            title={intl.get('SHANCHU')}
            visible={this.state.deleteVisible}
            onOk={this.handleToConfirmDelete}
            onCancel={() => this.setState({ deleteVisible: false })}
            okText={intl.get('QUEDING')}
            cancelText={intl.get('QUEXIAO')}
          >
            <p>{intl.get('QUEDINGSHANCHU')}</p>
          </Modal>
          <Nav history={this.props.history} props={this.props} />
          <div className="banner" onClick={this.handleGoIndex}>
            <div
              className="banner_top"
              style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}
            >
              <div
                className="banner_top_left"
                style={{ width: '4.5rem', height: '0.82rem' }}
              ></div>
              {/* <div className="banner_top_right" style={{ width: '100%', textAlign: 'right' }}>{intl.get('YISOUSHUANGYE')}</div> */}
            </div>
          </div>
          <div className="my_place">
            <div className="my_place_top">
              <div className="my_place_top_left">
                <Avatar
                  size={177}
                  icon={<AntDesignOutlined />}
                  src={this.state.userData?.path}
                />
              </div>
              <div className="my_place_top_right">
                <div className="my_place_top_right_info">
                  <div className="my_place_top_right_info_title">
                    {this.state.userData?.account}
                  </div>
                  <div className="my_place_top_right_info_sign">
                    <span>
                      {intl.get('XINGMIMIGHN')}：
                      {this.state.userData?.personName}
                    </span>
                    <span className="my_place_top_right_info_sign_email">
                      {intl.get('YOUXIANG')}：{this.state.userData?.email}
                    </span>
                  </div>
                </div>
                <div
                  className="my_place_top_right_icon"
                  onClick={this.handleChangeTab.bind(this, 5)}
                >
                  <SettingOutlined
                    style={{ fontSize: '0.2rem', color: '#18B2B0' }}
                  />
                  {intl.get('GERENSHOUCANG')}
                </div>
              </div>
            </div>

            <div className="my_place_tabs">{this.showShopTab()}</div>
          </div>
          <div>{this.judgeContent()}</div>
          <Foot history={this.props.history} />
        </div>

        <ReactWebsocket
          url={webSocketUrl}
          onMessage={this.onMessage} //接受信息的回调
          onOpen={this.onOpen} //websocket打开
          onClose={this.onClose} //websocket关闭
          reconnect={true}
          debug={true}
          ref={Websocket => {
            this.refWebSocket = Websocket
          }}
        />
        {/* 移动端==============================================================================================================================================================================================================================> */}

        <div className="phone_content person_phone_content">
          <div
            className="phone_person_top"
            style={{
              background: `url(${this.state.userData?.path}) `,
              backgroundSize: 'cover',
            }}
          ></div>
          <div className="phone_person_content">
            <div className="phone_person_top_first">
              <div className="phone_person_top_first_item">
                <LeftOutlined
                  style={{ color: '#fff', fontSize: '15px' }}
                  onClick={this.handleBack}
                />
              </div>
              <div
                className="phone_person_top_edit"
                onClick={this.handleEditPhone}
              >
                {intl.get('XIUGAIZILIAO')}
              </div>
            </div>

            <div className="phone_person_top_second">
              <div className="phone_person_top_second_avatar">
                <Avatar
                  size={100}
                  icon={<UserOutlined />}
                  src={this.state.userData?.path}
                />
                <div className="phone_person_top_second_name">
                  {this.state.userData?.account}
                </div>
                <div className="phone_person_top_second_mail">
                  {this.state.userData?.email}
                </div>
              </div>
            </div>
          </div>

          <div className="phone_person_content_tabs">
            {this.phoneShowShopTab()}
          </div>

          <div className="phone_person_content_tabs_content">
            {this.switchContent()}
          </div>
          <Popup
            position="top"
            visible={this.state.visible}
            bodyStyle={{ height: '100vh' }}
          >
            <div className="phone_popup_edit">
              <div className="phone_popup_edit_top">
                <div
                  className="phone_popup_edit_top_left"
                  onClick={() => {
                    this.setState({ visible: false })
                  }}
                >
                  <LeftOutlined style={{ color: '#000', fontSize: '15px' }} />
                </div>
                <div className="phone_popup_edit_top_right">修改资料</div>
              </div>

              <div className="phone_popup_edit_content">
                <div className="phone_popup_edit_content_avatar">
                  <Avatar
                    size={100}
                    icon={<UserOutlined />}
                    src={this.state.userData.path}
                  />
                  <div>
                    <ImgCrop>
                      <Upload
                        action={
                          process.env.REACT_APP_UPLOAD_API +
                          '/website/upload/uploadpic'
                        }
                        showUploadList={false}
                        fileList={this.state.fileList}
                        onPreview={this.handlePreview}
                        onChange={this.handleChange}
                        data={this.state.mainpathparms}
                        headers={this.state.headers}
                      >
                        <div className="phone_popup_edit_content_right">
                          {' '}
                          {intl.get('SHANGHCUANGTOUXIANG')}
                        </div>
                      </Upload>
                    </ImgCrop>
                  </div>
                </div>
                <div className="phone_popup_edit_content_form">
                  <div className="phone_person_content_tabs_content_item">
                    <div className="phone_person_content_tabs_content_item_left">
                      {intl.get('ZHANGHAO')}
                    </div>
                    <div className="phone_person_content_tabs_content_item_right">
                      {this.state.userData.account}
                    </div>
                  </div>
                  <div
                    className="phone_person_content_tabs_content_item"
                    onClick={this.handleEdit.bind(this, 2)}
                  >
                    <div className="phone_person_content_tabs_content_item_left">
                      {intl.get('XINGMIMIGHN')}
                    </div>
                    <div className="phone_person_content_tabs_content_item_right">
                      {this.state.userData.personName}
                    </div>
                  </div>
                  <div
                    className="phone_person_content_tabs_content_item"
                    onClick={this.handleEdit.bind(this, 4)}
                  >
                    <div className="phone_person_content_tabs_content_item_left">
                      {intl.get('SHOUJIHAOMA')}
                    </div>
                    <div className="phone_person_content_tabs_content_item_right">
                      {this.state.userData.phone}
                    </div>
                  </div>

                  <div
                    className="phone_person_content_tabs_content_item"
                    onClick={this.handleEdit.bind(this, 3)}
                  >
                    <div className="phone_person_content_tabs_content_item_left">
                      {intl.get('YOUXIANG')}
                    </div>
                    <div className="phone_person_content_tabs_content_item_right">
                      {this.state.userData.email}
                    </div>
                  </div>
                  <div
                    className="phone_person_content_tabs_content_item"
                    onClick={this.handleEdit.bind(this, 6)}
                  >
                    <div className="phone_person_content_tabs_content_item_left">
                      {intl.get('WEIXINHAO')}
                    </div>
                    <div className="phone_person_content_tabs_content_item_right">
                      {this.state.userData.wechat}
                    </div>
                  </div>
                  <div
                    className="phone_person_content_tabs_content_item"
                    onClick={this.handleEdit.bind(this, 5)}
                  >
                    <div className="phone_person_content_tabs_content_item_left">
                      {intl.get('MIMA')}
                    </div>
                    <div className="phone_person_content_tabs_content_item_right">
                      ********
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              title={this.state.editTitle}
              visible={this.state.editVisible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
            >
              {this.diffComponent()}
            </Modal>
          </Popup>
        </div>
      </>
    )
  }
}
